export function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-callback-ref/dist/es2015/assignRef.js
// module id = 50
// module chunks = 0